// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.14-XM80lRoYRUdkHMpUfMaX/mode=imports,min/optimized/keen-slider.js'

const { config } = window.BAO.Carousel
const {
  setInitialised,
  useDots,
  setCurrent,
  addWheelControls,
} = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class QuoteCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  static get requiredExternalElements () {
    return ['button']
  }

  connectedCallback () {
    super.connectedCallback()
    if (this.els?.slide?.elements?.length < 2) {
      this.els?.slides?.element.setAttribute('data-initialised', true)
      this.els?.slide?.element.setAttribute('aria-current', true)
      return
    }

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onResize = this.onResize.bind(this)
    this.debouncedResize = debounce(event => {
      this.onResize(event)
    }, 500)
    this.listeners.add(window, 'resize', this.debouncedResize)
  }

  setupCarousel () {
    return new KeenSlider(this.els.slides.element, this.options(), [
      setInitialised(),
      useDots(this.externalEls?.button?.elements),
      setCurrent(),
      addWheelControls('horizontal'),
    ])
  }

  options () {
    return {
      selector: this.els.slide.selector,
      loop: true,
      mode: 'snap',
      defaultAnimation: {
        duration: 0,
      },
      breakpoints: {
        '(min-width: 1024px)': {
          drag: false,
        },
      },
      dragSpeed: config.dragSpeed,
      slides: {
        perView: '1',
      },
      created: () => {
        this.autoplay(true)
        this.externalEls?.button?.elements.forEach(button => {
          button.addEventListener('click', () => {
            this.autoplay(true)
          })
        })
      },
      dragStarted: () => {
        this.autoplay(false)
      },
      dragEnded: () => {
        this.autoplay(true)
      },
    }
  }

  autoplay (run) {
    clearInterval(this.interval)

    this.interval = setInterval(() => {
      if (run && this.carousel) {
        this.carousel.next()
      }
    }, this.intervalDelay)
  }

  onResize () {
    if (!this.carousel) return
    this.carousel.update(this.options(), this.carousel.track.details.rel)
  }

  get intervalDelay () {
    return this.dataset?.intervalDelay?.length
      ? Number(this.dataset.intervalDelay)
      : 4000
  }
}

if (!customElements.get('quote-carousel')) {
  customElements.define('quote-carousel', QuoteCarousel)
}
